import { render, staticRenderFns } from "./textbookReport.vue?vue&type=template&id=08ae2f92&scoped=true"
import script from "./textbookReport.vue?vue&type=script&lang=js"
export * from "./textbookReport.vue?vue&type=script&lang=js"
import style0 from "./textbookReport.vue?vue&type=style&index=0&id=08ae2f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ae2f92",
  null
  
)

export default component.exports